import { LANGS, setLang, useT } from "@/lib/i18n";

export const LangSwitch = ({ className = "" }) => {
  const { lang } = useT();
  return (
    <div data-testid="lang-switch" className={`no-print inline-flex rounded-lg border border-white/10 overflow-hidden ${className}`}>
      {LANGS.map((l) => (
        <button key={l} type="button" data-testid={`lang-${l}`} onClick={() => setLang(l)}
          className={`h-9 px-2.5 text-xs font-mono font-bold uppercase transition-colors ${lang === l ? "bg-blue-600 text-white" : "text-slate-400 hover:text-white hover:bg-white/5"}`}>
          {l}
        </button>
      ))}
    </div>
  );
};
